export class UsersFiltersPath {
  public static readonly FIRST_NAME = 'firstName';
  public static readonly LAST_NAME = 'lastName';
  public static readonly EMAIL = 'email';
  public static readonly PHONE_NUMBER = 'phoneNumber';
  public static readonly DNI = 'dni';
  public static readonly CLIENT = 'clients.id';
  public static readonly TOWN = 'town.id';
  public static readonly ROLE = 'role';
  public static readonly TYPE = 'type';
  public static readonly STATUS = 'status';
}
